<template>
  <div class="col-12 no-gutters container mt-3">
    <div class="e-chart-container">
      <div class="title-and-chart">
        <div :id="eChartId" class="e-chart">
          <chart :options="options"></chart>
        </div>
        <div :id="eChartMiniId">
          <img :src="imageUrl" class="pdf-content-image-width hidden-dashboard-display"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EChartsMixins from "../../mixins/EChartsMixins";
import BarHorizontalService from "../../services/echarts/bar.horizontal.service";
import SymbolService from "../../services/symbol.service";
import $ from "jquery";

export default {
  name: "IndividualSalesWizardChart",
  mixins: [EChartsMixins],
  props: {
    eChartId: {
      type: String,
      default: "individual-sales-wizard-chart"
    },
    eChartMiniId: {
      type: String,
      default: "individual-sales-wizard-chart-mini"
    },
    inputReportTypeName: {
      type: String,
      default: "Chart - Individual Sales Wizard"
    },
    modalId: {
      type: String,
      default: "individual-sales-wizard-chart"
    },
    isSavedCard: {
      type: Boolean,
      default: false
    },
    inputClientChart: {
      type: Object,
      default: () => ({})
    },
    clientId: {
      type: Number,
      default: 0
    },
    inputDownloadFileName: {
      type: String,
      default: "Individual Sales Wizard"
    },
    companyColorList: {
      type: Array,
      default: () => []
    },
    maxChartedRespondents: {
      type: Number,
      default: 6
    },
    inputIndividualSalesWizardData: {
      type: [Array, Object],
      default: () => ([])
    }
  },
  data() {
    return {
      charts: [],
      imageUrl: "",
      options: this.buildIndividualSalesWizardOptions([])
    };
  },
  mounted() {},
  methods: {
    getChartOptions: function() {
      return this.options;
    },
    setData(data) {
      const rows = this.getRows(data);
      this.options = this.buildIndividualSalesWizardOptions(rows);
    },
    getRows(data) {
      let rows = [];
      if (Array.isArray(data)) {
        rows = data;
      } else if (data && Array.isArray(data.rows)) {
        rows = data.rows;
      }
      return JSON.parse(JSON.stringify(rows.slice(0, this.maxChartedRespondents)));
    },
    getDecisionStyles() {
      return {
        charismatics: {
          label: "Charismatic",
          value: 5,
          symbol: SymbolService.getCharismaticsSymbol(),
          symbolSize: [16, 14]
        },
        thinkers: {
          label: "Thinker",
          value: 4,
          symbol: SymbolService.getThinkersSymbol(),
          symbolSize: [16, 16]
        },
        skeptics: {
          label: "Skeptic",
          value: 3,
          symbol: SymbolService.getSkepticsSymbol()
        },
        protectors: {
          label: "Protector",
          value: 2,
          symbol: SymbolService.getProtectorsSymbol()
        },
        pacesetters: {
          label: "Pacesetter",
          value: 1,
          symbol: SymbolService.getControllersSymbol()
        }
      };
    },
    normalizeDecisionStyle(value) {
      return String(value || "")
        .trim()
        .toLowerCase();
    },
    getDecisionStyle(value) {
      const styles = this.getDecisionStyles();
      return styles[this.normalizeDecisionStyle(value)] || null;
    },
    getDecisionStyleValue(value) {
      const style = this.getDecisionStyle(value);
      return style == null ? null : style.value;
    },
    getDecisionStyleSymbol(value) {
      const style = this.getDecisionStyle(value);
      return style == null ? "none" : style.symbol;
    },
    getDecisionStyleSymbolSize(value) {
      const style = this.getDecisionStyle(value);
      return style != null && style.symbolSize ? style.symbolSize : [12, 12];
    },
    getDecisionStyleAxisFontSize() {
      return 10;
    },
    getDecisionStyleAxisLabel(value) {
      const labels = {
        5: "Charismatic",
        4: "Thinker",
        3: "Skeptic",
        2: "Protector",
        1: "Pacesetter"
      };
      return labels[value] || "";
    },
    isMissingValue(value) {
      const normalizedValue = String(value == null ? "" : value).trim().toLowerCase();
      return normalizedValue == "" || normalizedValue == "--" || normalizedValue == "null" || normalizedValue == "undefined";
    },
    shouldShowInLegend(definition) {
      return definition.showInLegend !== false;
    },
    isDecisionStyleDefinition(definition) {
      return ["idealDecisionStyle", "actualDecisionStyle", "competitorDecisionStyle"].includes(definition.fieldName);
    },
    getNotSelectedBarData() {
      return {
        value: 4.85,
        notSelected: true,
        itemStyle: {
          color: "transparent",
          borderWidth: 0
        },
        label: {
          color: "#000000"
        }
      };
    },
    getNotSelectedOffsetData() {
      return {
        value: 0.01,
        itemStyle: {
          color: "transparent",
          borderWidth: 0
        },
        label: {
          show: false
        },
        tooltip: {
          show: false
        }
      };
    },
    getBarLabel(params) {
      if (params.data && params.data.notSelected) {
        return "No data selected";
      }
      return this.getDecisionStyleAxisLabel(params.value);
    },
    matchesSeriesDefinition(row, definition) {
      if (definition.matchField) {
        const rowValue = row[definition.matchField];
        if (Array.isArray(definition.matchValues)) {
          return definition.matchValues.includes(rowValue);
        }
        return rowValue == definition.matchValue;
      }
      return true;
    },
    getSeriesData(rows, definition) {
      return rows.map(row => {
        if (!this.matchesSeriesDefinition(row, definition)) {
          return null;
        }
        if (definition.matchMissingField && !this.isMissingValue(row[definition.matchMissingField])) {
          return null;
        }
        return this.getDecisionStyleValue(row[definition.fieldName]);
      });
    },
    getIconMarkPointData(rows, definition) {
      return rows.map(row => {
        if (!this.matchesSeriesDefinition(row, definition)) {
          return null;
        }
        const value = this.getDecisionStyleValue(row[definition.fieldName]);
        if (value == null) {
          return null;
        }
        return {
          name: row.name,
          coord: [value, row.name],
          decisionStyle: row[definition.fieldName],
          symbol: this.getDecisionStyleSymbol(row[definition.fieldName]),
          symbolSize: this.getDecisionStyleSymbolSize(row[definition.fieldName]),
          symbolOffset: [-12, definition.iconOffsetY]
        };
      }).filter(value => value != null);
    },
    getIndividualSalesWizardSeries(baseSeries, seriesDefinitions, rows) {
      return baseSeries.reduce((chartSeries, series, index) => {
        const definition = seriesDefinitions[index];
        let individualSalesWizardBarSeries = {};
        $.extend(true, individualSalesWizardBarSeries, series, {
          xAxisIndex: 0,
          yAxisIndex: 0,
          barWidth: 23,
          barGap: "8%",
          barCategoryGap: "24%",
          itemStyle: {
            color: definition.color
          },
          label: {
            show: true,
            position: "insideLeft",
            color: "#ffffff",
            fontSize: this.getDecisionStyleAxisFontSize(),
            fontFamily: "Franklin Gothic Demi Cond, sans-serif",
            formatter: params => this.getBarLabel(params)
          },
          stack: definition.stack,
          data: this.isDecisionStyleDefinition(definition) ? this.getDecisionStyleSeriesData(rows, definition) : this.getSeriesData(rows, definition),
          markPoint: {
            symbolSize: [12, 12],
            itemStyle: {
              color: "#ffffff"
            },
            label: {
              show: false
            },
            tooltip: {
              show: false
            },
            silent: true,
            data: this.getIconMarkPointData(rows, definition)
          },
          z: 2
        });
        if (this.isDecisionStyleDefinition(definition)) {
          let notSelectedOffsetSeries = {};
          $.extend(true, notSelectedOffsetSeries, series, {
            name: `${definition.name} No data available Offset`,
            xAxisIndex: 0,
            yAxisIndex: 0,
            barWidth: 23,
            barGap: "8%",
            barCategoryGap: "24%",
            itemStyle: {
              color: "transparent",
              borderWidth: 0
            },
            label: {
              show: false
            },
            stack: definition.stack,
            data: this.getDecisionStyleOffsetSeriesData(rows, definition),
            silent: true,
            tooltip: {
              show: false
            },
            z: 1
          });
          chartSeries.push(notSelectedOffsetSeries);
        }
        chartSeries.push(individualSalesWizardBarSeries);
        return chartSeries;
      }, []);
    },
    getDecisionStyleSeriesData(rows, definition) {
      return rows.map(row => {
        if (!this.matchesSeriesDefinition(row, definition)) {
          return null;
        }
        if (definition.matchMissingField && !this.isMissingValue(row[definition.matchMissingField])) {
          return null;
        }
        const value = this.getDecisionStyleValue(row[definition.fieldName]);
        return value == null ? this.getNotSelectedBarData() : value;
      });
    },
    getDecisionStyleOffsetSeriesData(rows, definition) {
      return rows.map(row => {
        if (!this.matchesSeriesDefinition(row, definition)) {
          return null;
        }
        if (definition.matchMissingField && !this.isMissingValue(row[definition.matchMissingField])) {
          return null;
        }
        const value = this.getDecisionStyleValue(row[definition.fieldName]);
        return value == null ? this.getNotSelectedOffsetData() : null;
      });
    },
    getIconOffsetYLookup(rows) {
      return {
          idealDecisionStyle: 0,
          actualDecisionStyle: 0,
          competitorDecisionStyle: 0
      };
    },
    buildSeriesDefinitions(rows) {
      const iconOffsetYLookup = this.getIconOffsetYLookup(rows);
      const seriesDefinitions = [
        {
          name: "Ideal",
          fieldName: "idealDecisionStyle",
          color: "#000000",
          iconOffsetY: iconOffsetYLookup.idealDecisionStyle,
          stack: "idealDecisionStyle"
        }
      ];
      this.getCompanySeriesGroups(rows, "actualCompany").forEach(companyGroup => {
        seriesDefinitions.push({
          name: companyGroup.name,
          fieldName: "actualDecisionStyle",
          color: this.getCompanyColor(companyGroup.name, "#00B050"),
          iconOffsetY: iconOffsetYLookup.actualDecisionStyle,
          stack: "actualDecisionStyle",
          matchField: "actualCompany",
          matchValues: companyGroup.values
        });
      });
      if (rows.some(row => this.isMissingValue(row.company))) {
        seriesDefinitions.push({
          name: "Company",
          fieldName: "actualDecisionStyle",
          color: "#ffffff",
          iconOffsetY: iconOffsetYLookup.actualDecisionStyle,
          stack: "actualDecisionStyle",
          showInLegend: false,
          matchMissingField: "company"
        });
      }
      this.getCompanySeriesGroups(rows, "competitorCompany").forEach(competitorCompanyGroup => {
        seriesDefinitions.push({
          name: competitorCompanyGroup.name,
          fieldName: "competitorDecisionStyle",
          color: this.getCompanyColor(competitorCompanyGroup.name, "#DDEBF7"),
          iconOffsetY: iconOffsetYLookup.competitorDecisionStyle,
          stack: "competitorDecisionStyle",
          matchField: "competitorCompany",
          matchValues: competitorCompanyGroup.values
        });
      });
      if (rows.some(row => this.isMissingValue(row.competitorCompany))) {
        seriesDefinitions.push({
          name: "Competitor",
          fieldName: "competitorDecisionStyle",
          color: "#ffffff",
          iconOffsetY: iconOffsetYLookup.competitorDecisionStyle,
          stack: "competitorDecisionStyle",
          showInLegend: false,
          matchMissingField: "competitorCompany"
        });
      }
      return seriesDefinitions;
    },
    getCompanySeriesGroups(rows, fieldName) {
      return this.getUniqueValues(rows, fieldName).reduce((groups, companyName) => {
        const legendName = this.getCompanyLegendName(companyName);
        let group = groups.find(companyGroup => companyGroup.name == legendName);
        if (typeof group == "undefined") {
          group = {
            name: legendName,
            values: []
          };
          groups.push(group);
        }
        group.values.push(companyName);
        return groups;
      }, []);
    },
    getCompanyLegendName(companyName) {
      return this.hasCompanyColor(companyName) ? this.getCompanyDisplayName(companyName) : "Other";
    },
    getCompanyDisplayName(companyName) {
      return companyName == "Other (specify below)" ? "Other" : companyName;
    },
    hasCompanyColor(companyName) {
      return typeof this.getCompanyColorDefinition(companyName) != "undefined";
    },
    getCompanyColorDefinition(companyName) {
      const displayName = this.getCompanyDisplayName(companyName);
      return this.companyColorList.find(companyColor => companyColor.companyName == companyName || this.getCompanyDisplayName(companyColor.companyName) == displayName);
    },
    getUniqueValues(rows, fieldName) {
      return rows.reduce((values, row) => {
        const value = row[fieldName];
        if (value != null && value != "" && value != "--" && !values.includes(value)) {
          values.push(value);
        }
        return values;
      }, []);
    },
    getCompanyColor(companyName, defaultColor) {
      const searchableCompany = this.getCompanyColorDefinition(companyName);
      if (typeof searchableCompany != "undefined" && searchableCompany.color != "") {
        return searchableCompany.color;
      }
      return defaultColor;
    },
    buildIndividualSalesWizardOptions(rows) {
      const rowNames = rows.map(row => row.name);
      const seriesDefinitions = this.buildSeriesDefinitions(rows);
      const legendData = seriesDefinitions.filter(this.shouldShowInLegend).map(definition => definition.name);
      const seriesData = seriesDefinitions.map(definition => ({
        name: definition.name,
        data: this.getSeriesData(rows, definition)
      }));

      BarHorizontalService.setBarWidth(21);
      BarHorizontalService.setShowSnap(this.isSavedCard);
      BarHorizontalService.setShowToolbox(false);
      BarHorizontalService.setShowLabel(false);
      BarHorizontalService.setShowLegend(true);
      BarHorizontalService.setShowTooltip(true);
      BarHorizontalService.setIsMultiWave(rows.length > 1);
      BarHorizontalService.setChartType("bar-horizontal");
      BarHorizontalService.setLegendData(legendData);
      BarHorizontalService.setSeriesData(seriesData);
      BarHorizontalService.setYAxisData(rowNames);

      let options = BarHorizontalService.getOptions(
        false,
        false,
        this,
        this.modalId,
        this.inputReportTypeName,
        rows.length,
        this.inputDownloadFileName
      );

      $.extend(true, options, {
        animation: false,
        color: seriesDefinitions.map(definition => definition.color),
        title: {
          text: "",
          show: false
        },
        tooltip: {
          trigger: "item",
          formatter: params => {
            if (params.seriesType == "scatter") {
              return `${params.name}<br/>${params.seriesName.replace(" Icon", "")}: ${params.data.decisionStyle}`;
            }
            if (params.data && params.data.notSelected) {
              return `${params.name}<br/>${params.seriesName}: No data selected`;
            }
            return `${params.name}<br/>${params.seriesName}: ${params.value == null ? "--" : this.getDecisionStyleAxisLabel(params.value)}`;
          }
        },
        legend: {
          orient: "vertical",
          right: null,
          left: 805,
          top: 22,
          icon: "rect",
          itemWidth: 6,
          itemHeight: 6,
          borderWidth: 0,
          width: null,
          textStyle: {
            color: "#000",
            fontSize: 11,
            fontFamily: "Franklin Gothic Demi Cond, sans-serif",
          },
          data: legendData
        },
        toolbox: {
          show: true,
          right: 10
        },
        grid: [
          {
            left: 118,
            right: 178,
            top: 24,
            bottom: 36,
            backgroundColor: "#F8F8F8",
            containLabel: false,
            show: true
          }
        ],
        xAxis: [
          {
            type: "value",
            min: 0,
            max: 6,
            interval: 1,
            axisLabel: {
              color: "#000000",
              fontSize: this.getDecisionStyleAxisFontSize(),
              fontFamily: "Franklin Gothic Demi Cond, sans-serif",
              fontWeight: "bold",
              formatter: value => this.getDecisionStyleAxisLabel(value)
            },
            axisTick: { show: false },
            axisLine: {
              show: false,
              lineStyle: { color: "#8a8a8a" }
            },
            splitLine: {
              lineStyle: { color: "#ffffff" }
            }
          }
        ],
        yAxis: [
          {
            type: "category",
            inverse: true,
            data: rowNames,
            axisLine: {
              lineStyle: { color: "#8a8a8a" }
            },
            axisTick: { show: false },
            axisLabel: {
              color: "#000000",
              fontSize: 10,
              fontFamily: "Franklin Gothic Demi Cond, sans-serif",
              fontWeight: 700,
              margin: 8
            }
          },
          {
            type: "value",
            inverse: true,
            min: -0.5,
            max: Math.max(rows.length - 0.5, 0.5),
            interval: 1,
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLine: { show: false }
          }
        ],
        series: this.getIndividualSalesWizardSeries(options.series, seriesDefinitions, rows)
      });
      options.toolbox.show = true;
      return options;
    },
    saveTable(table) {
      this.$emit("save-table", table);
    },
    saveCriteria(criteria) {
      this.$emit("save-criteria", criteria);
    },
    processChart: function(runChart = false, value, eChartCriteria) {
      if (runChart == true) {
        this.setData(value);
        this.eChartCriteria = JSON.parse(JSON.stringify(eChartCriteria));
        this.initChart();
        this.$emit("save-criteria", true);
        this.$emit("save-table");
      }
    }
  },
  watch: {
    inputIndividualSalesWizardData: {
      deep: true,
      handler(value) {
        const rows = this.getRows(value);
        if (rows.length > 0) {
          this.setData(rows);
          this.initChart();
        }
      }
    }
  }
};
</script>
